import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { SecondaryButton, DangerButton } from "./ButtonComponents";

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = "Onay",
  message = "Bu işlemi yapmak istediğinizden emin misiniz?",
  confirmText = "Evet",
  cancelText = "İptal",
  onConfirm,
  onCancel,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!isOpen || !mounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-borderColor text-text rounded-2xl shadow-xl p-6 w-96 max-w-[90vw] animate-modalIn">
        <h3 className="text-lg font-bold mb-2">{title}</h3>
        <p className="mb-6 opacity-80 text-sm">{message}</p>
        <div className="flex justify-end gap-2">
          <SecondaryButton onClick={onCancel}>
            {cancelText}
          </SecondaryButton>
          <DangerButton onClick={onConfirm}>
            {confirmText}
          </DangerButton>
        </div>
      </div>
    </div>,
    document.body
  );
};
